import {
  patchConversationMessage,
  type PatchConversationMessageBody,
} from 'api/v2/AI';
import useMutation from 'hooks/react-query/useMutation';

type UsePatchConversationMessageResult = {
  patchMessage: (body: PatchConversationMessageBody) => Promise<unknown>;
  isLoading: boolean;
};

const usePatchConversationMessage = (
  conversationId: string,
  messageId: string,
): UsePatchConversationMessageResult => {
  const { mutateAsync, isLoading } = useMutation(
    (body: PatchConversationMessageBody) =>
      patchConversationMessage(conversationId, messageId, body),
  );

  return { patchMessage: mutateAsync, isLoading };
};

export default usePatchConversationMessage;
